/*
  Quickvit - Klaviyo popup unlock safety net (25 Oct 2026).
  Dan reported: tap "No thanks" on the email popup and the page freezes.
  Klaviyo only removes body.klaviyo-prevent-body-scrolling (overflow:hidden) and
  unmounts its faded-out form when its close animation fires animationend /
  transitionend. When that event never arrives, the page stays locked and the
  invisible form keeps catching taps over the middle of the screen.

  This only acts on a tap on the popup's own close controls (the X, or a
  "No thanks" button). If the lock is still on 1.5s after that tap, the close
  clearly stalled: remove the lock and make the leftover popup layer click-through.
  It never judges visibility, so it cannot unlock a popup that is still open.
  If Klaviyo opens a form again it re-adds the lock, and the click-through is undone.
*/
(function () {
  var LOCK = 'klaviyo-prevent-body-scrolling';
  var GHOST = 'qv-kl-ghost';
  var ROOTS = '.needsclick, [class*="kl-private-reset"]';
  var pending = null;

  function isCloseControl(el) {
    var btn = el && el.closest && el.closest('button, [role="button"]');
    if (!btn || !btn.closest(ROOTS)) return false;
    if (btn.classList.contains('klaviyo-close-form')) return true;
    if (/close/i.test(btn.getAttribute('aria-label') || '')) return true;
    return /^\s*no,?\s*thanks?\b/i.test(btn.textContent || '');
  }

  function release() {
    pending = null;
    if (!document.body.classList.contains(LOCK)) return;
    document.body.classList.remove(LOCK);
    var layers = document.querySelectorAll('[role="dialog"]');
    for (var i = 0; i < layers.length; i++) {
      var d = layers[i];
      if (!d.matches(ROOTS) && !d.closest(ROOTS)) continue;
      // Inline !important: Klaviyo's own reset stylesheet beats a class rule.
      var nodes = [d].concat([].slice.call(d.querySelectorAll('*')));
      for (var j = 0; j < nodes.length; j++) {
        nodes[j].classList.add(GHOST);
        nodes[j].style.setProperty('pointer-events', 'none', 'important');
      }
    }
  }

  document.addEventListener('click', function (e) {
    if (!isCloseControl(e.target)) return;
    if (pending) clearTimeout(pending);
    pending = setTimeout(release, 1500);
  }, true);

  // A form opening again re-adds the lock: give its elements their taps back.
  new MutationObserver(function () {
    if (!document.body.classList.contains(LOCK)) return;
    var g = document.querySelectorAll('.' + GHOST);
    for (var i = 0; i < g.length; i++) {
      g[i].classList.remove(GHOST);
      g[i].style.removeProperty('pointer-events');
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
